import React from "react";
import ReactDOM from "react-dom/client";
import PilbaraPredictiveMaintenance from "./pilbara-predictive-maintenance";
import "../../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PilbaraPredictiveMaintenance />
  </React.StrictMode>,
);
